/**
 * Extract a safe, user-friendly string from an axios error.
 *
 * FastAPI's Pydantic validation errors return `detail` as an ARRAY of
 * `{loc, msg, type, input}` objects. Passing that array directly into
 * `toast.error(...)` / rendering it as a React child throws
 * "Objects are not valid as a React child" which, with no Error
 * Boundary in place, unmounts the whole app and leaves the user on a
 * blank/black page.
 *
 * Always pipe axios errors through this helper before display.
 */
export function extractApiError(error, fallback = "Request failed") {
  const detail = error?.response?.data?.detail;

  if (!detail) {
    return error?.message || fallback;
  }

  if (typeof detail === "string") {
    return detail;
  }

  if (Array.isArray(detail)) {
    // Pydantic validation error shape: [{loc, msg, type, input}, ...]
    const msgs = detail
      .map((d) => {
        if (typeof d === "string") return d;
        if (d && typeof d === "object") {
          const loc = Array.isArray(d.loc) ? d.loc.slice(-1)[0] : "";
          const msg = d.msg || d.message || "";
          return loc ? `${loc}: ${msg}` : msg;
        }
        return "";
      })
      .filter(Boolean);
    return msgs.join("; ") || fallback;
  }

  if (typeof detail === "object") {
    return detail.msg || detail.message || fallback;
  }

  return String(detail);
}
